import { render, staticRenderFns } from "./SelectProductInventory.vue?vue&type=template&id=2f84b885&"
import script from "./SelectProductInventory.vue?vue&type=script&lang=ts&"
export * from "./SelectProductInventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f84b885')) {
      api.createRecord('2f84b885', component.options)
    } else {
      api.reload('2f84b885', component.options)
    }
    module.hot.accept("./SelectProductInventory.vue?vue&type=template&id=2f84b885&", function () {
      api.rerender('2f84b885', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StockAdjustment/SelectProductInventory.vue"
export default component.exports